if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async changeAttributes (key, value) {
        const responsePostCart = await fetch("/cart/update.js", { method: "POST", headers: {'X-Requested-With': 'XMLHttpRequest','Content-Type': 'application/json;'},  body: JSON.stringify({attributes: {[key]: value}})});
        return responsePostCart;
      }

      async getSplitCarts () {

        const currentCart = await this.getCart();

        
          const itemsCart = currentCart?.items;

          const items = itemsCart?.map(item => ({
            variantId: `gid://shopify/ProductVariant/${item.variant_id}`,
            quantity: item.quantity,
            properties: {
              ...item.properties
            }
          }));

          console.log("items",items);

            /**
             "gid://shopify/Location/70755451113", // bodega
              "gid://shopify/Location/76828246249", // alamedas
              "gid://shopify/Location/76828737769", // Buenavista Crocs
              "gid://shopify/Location/89179980009", // CEDI IX Comercio Colombia San Diego
              "gid://shopify/Location/76828868841", // Chipichape Crocs
              // "gid://shopify/Location/82080891113",  El Edén Crocs
              "gid://shopify/Location/76827721961", // El Tesoro Medellín
              "gid://shopify/Location/76828180713", // Fontanar
              "gid://shopify/Location/76828573929", // Gran Estación Crocs
              "gid://shopify/Location/76828213481", // Jardin Plaza Cali
              "gid://shopify/Location/76827984105", // Jardín Plaza Cúcuta
              "gid://shopify/Location/76827754729", // La Serrezuela
              //"gid://shopify/Location/76828475625", Mall Plaza Barranquilla K.Crocs
              "gid://shopify/Location/76828639465", // Mall Plaza Cali Crocs
              "gid://shopify/Location/76828803305", // Mall Plaza Cartagena Crocs
              // "gid://shopify/Location/76828541161",  Mall Plaza Cartagena K.Crocs
              // "gid://shopify/Location/76828311785",  Mayorca Sabaneta
              "gid://shopify/Location/76828082409", // Parque Arboleda Pereira
              // "gid://shopify/Location/76828606697",  Plaza Central Crocs
              "gid://shopify/Location/76828016873", // Titan Plaza
              //"gid://shopify/Location/79121711337",  Único Outlet Bucaramanga Crocs
              "gid://shopify/Location/76828836073", // Zona T Crocs
          * 
          */

          const priorityLocation = [
            "gid://shopify/Location/90563510525", 
            "gid://shopify/Location/90563543293", 
            "gid://shopify/Location/90563576061", 
            "gid://shopify/Location/90563838205", 
            "gid://shopify/Location/90563903741", 
            "gid://shopify/Location/90563936509", 
            "gid://shopify/Location/90563969277", 
            "gid://shopify/Location/90564002045", 
            "gid://shopify/Location/90564034813", 
            "gid://shopify/Location/90564067581", 
            "gid://shopify/Location/90564133117", 
            "gid://shopify/Location/90564165885"
          ]

          const formData = new FormData();
          formData.append("items", JSON.stringify(items));
          formData.append("priorityLocation", JSON.stringify(priorityLocation));

          const response = await fetch(
            "https://generates-inputs-furniture-lincoln.trycloudflare.com/apps/split-carts",
            {
              method: "POST",
              body: formData
            }
          );

          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }

          const data = await response.json();

          console.log("data",data);

          const desiredLines = [];

          let groupIndex = 1;

          for (const [locationName, groupedItems] of Object.entries(data.groups)) {

            const groupKey = `group_${groupIndex}`;

            for (const groupedItem of groupedItems) {

              const cartItem = currentCart.items.find(item => {
                const sameVariant =
                  `gid://shopify/ProductVariant/${item.variant_id}` === groupedItem.variantId;

                const sameStore =
                  item.properties?.store_selected === groupedItem?.properties?.store_selected;

                return sameVariant && sameStore;
              });

              if (!cartItem) continue;

              desiredLines.push({
                variantId: groupedItem.variantId,
                quantity: groupedItem.quantity,
                properties: {
                  ...cartItem.properties,

                  group_store_selected: locationName,

                  store_selected: cartItem.properties?.store_selected
                }
              });
            }

            groupIndex++;
          }

          if(desiredLines?.length > 0){

            await fetch("/cart/clear.js", {
              method: "POST"
            });

            await fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                items: desiredLines.map(item => ({
                  id: item.variantId.replace(
                    "gid://shopify/ProductVariant/",
                    ""
                  ),
                  quantity: item.quantity,
                  properties: item.properties
                }))
              })
            })
          }
        
      }

      async getCart(){
        const responseCart = await fetch("/cart.json");
        return await responseCart.json();
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(async () => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);

            const responseChangeAttribute = await this.changeAttributes("change_cart_client", "true");

            //this.getSplitCarts();
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
